import * as React from "react";
import { Form } from "react-bootstrap";
import RushProcessing from "../form/RushProcessing";

export default function RenewalStep4({ state, onChange, trademarkRushProcessing, validated }) {
  return (
    <div className="question step-6">
      <Form id="TrademarkForm" noValidate validated={validated}>
        <RushProcessing trademarkRushProcessing={trademarkRushProcessing} onChange={onChange} state={state}/>
      </Form>
    </div>
  );
}
